export const navLinks = [
  {
    name: "SEARCH",
    url: "/search",
    featured: false,
  },
  {
    name: "TRENDING",
    url: "/spotlight",
    featured: false,
  },
  {
    name: "BLOG",
    url: "/blog",
    featured: false,
  },
  {
    name: "KURB PRO",
    url: "/plans",
    featured: true,
  },
];

export const analyticsReports = [
  { label: "2026 Q2", slug: "2026-Q2" },
  { label: "2026 Q1", slug: "2026-Q1" },
];

export const socialLinks = [
  {
    name: "INSTAGRAM",
    url: "https://www.instagram.com/kurb.online",
    featured: false,
  },
  {
    name: "DISCORD",
    url: "https://discord.gg/jSh7n6ju8H",
    featured: false,
  },
  {
    name: "PINTEREST",
    url: "https://pinterest.com/kurbonline",
    featured: false,
  },
  {
    name: "LINKEDIN",
    url: "https://www.linkedin.com/company/kurb-online",
    featured: false,
  },
  {
    name: "TIK TOK",
    url: "https://www.tiktok.com/@kurb.online",
    featured: false,
  },
];

export const infoLinks = [
  {
    name: "ABOUT",
    url: "/about",
    featured: false,
  },
  {
    name: "HOW-TO",
    url: "/how-to",
    featured: false,
  },
  {
    name: "VENDORS",
    url: "/vendors",
    featured: false,
  },
  {
    name: "BRANDS",
    url: "/brands",
    featured: false,
  },
  {
    name: "PROXIES",
    url: "/proxies",
    featured: false,
  },
];

export const typeSelection: Filter[] = [
  { id: 1, label: "Tops", value: "tops", sortOrder: 1 },
  { id: 2, label: "Bottoms", value: "bottoms", sortOrder: 2 },
  { id: 3, label: "Outerwear", value: "outerwear", sortOrder: 3 },
  { id: 4, label: "Bags", value: "bags", sortOrder: 4 },
  { id: 5, label: "Eyewear", value: "eyewear", sortOrder: 5 },
  { id: 6, label: "Footwear", value: "footwear", sortOrder: 6 },
  { id: 7, label: "Accessories", value: "accessories", sortOrder: 7 },
  { id: 9, label: "Dresses", value: "dresses", sortOrder: 9 },
  { id: 10, label: "Set", value: "set", sortOrder: 10 },
  { id: 11, label: "Jewelry", value: "jewelry", sortOrder: 11 },
  { id: 12, label: "Hats", value: "hats", sortOrder: 12 },
];

export const IMPLICIT_EXCLUDED_TYPES = ["books", "fragrances"];

export const regionSelection: Filter[] = [
  { id: 150, label: "Europe", value: "150" },
  { id: 21, label: "North America", value: "021" },
  { id: 9, label: "Oceania", value: "009" },
  { id: 142, label: "Asia", value: "142" },
  { id: 419, label: "South America", value: "419" },
  { id: 2, label: "Africa", value: "002" },
];

export const regionMap: Record<string, string> = {
  "150": "Europe",
  "021": "North America",
  "009": "Oceania",
  "142": "Asia",
  "419": "South America",
  "002": "Africa",
};

export const countrySelection: Filter[] = [
  { label: "Albania", value: "AL", id: 1, group: "Europe", region: "150" },
  { label: "Algeria", value: "DZ", id: 2, group: "Africa", region: "002" },
  { label: "Andorra", value: "AD", id: 3, group: "Europe", region: "150" },
  { label: "Austria", value: "AT", id: 4, group: "Europe", region: "150" },
  { label: "Australia", value: "AU", id: 5, group: "Oceania", region: "009" },
  { label: "Bahrain", value: "BH", id: 6, group: "Asia", region: "142" },
  { label: "Belgium", value: "BE", id: 7, group: "Europe", region: "150" },
  {
    label: "Brazil",
    value: "BR",
    id: 8,
    group: "South America",
    region: "419",
  },
  { label: "Bulgaria", value: "BG", id: 9, group: "Europe", region: "150" },
  {
    label: "Canada",
    value: "CA",
    id: 10,
    group: "Northern America",
    region: "021",
  },
  {
    label: "Canary Islands",
    value: "CI",
    id: 11,
    group: "Europe",
    region: "150",
  },
  { label: "China", value: "CN", id: 12, group: "Asia", region: "142" },
  { label: "Croatia", value: "HR", id: 13, group: "Europe", region: "150" },
  { label: "Cyprus", value: "CY", id: 14, group: "Europe", region: "150" },
  {
    label: "Czech Republic",
    value: "CZ",
    id: 15,
    group: "Europe",
    region: "150",
  },
  { label: "Denmark", value: "DK", id: 16, group: "Europe", region: "150" },
  { label: "Estonia", value: "EE", id: 17, group: "Europe", region: "150" },
  { label: "Finland", value: "FI", id: 18, group: "Europe", region: "150" },
  { label: "France", value: "FR", id: 19, group: "Europe", region: "150" },
  { label: "Germany", value: "DE", id: 20, group: "Europe", region: "150" },
  { label: "Georgia", value: "GE", id: 21, group: "Asia", region: "142" },
  { label: "Greece", value: "GR", id: 22, group: "Europe", region: "150" },
  {
    label: "Guadeloupe",
    value: "GP",
    id: 23,
    group: "South America",
    region: "419",
  },
  { label: "Hong Kong", value: "HK", id: 24, group: "Asia", region: "142" },
  { label: "Hungary", value: "HU", id: 25, group: "Europe", region: "150" },
  { label: "India", value: "IN", id: 26, group: "Asia", region: "142" },
  { label: "Indonesia", value: "ID", id: 27, group: "Asia", region: "142" },
  { label: "Ireland", value: "IE", id: 28, group: "Europe", region: "150" },
  { label: "Italy", value: "IT", id: 29, group: "Europe", region: "150" },
  { label: "Japan", value: "JP", id: 30, group: "Asia", region: "142" },
  { label: "Kazakhstan", value: "KZ", id: 31, group: "Asia", region: "142" },
  { label: "Kenya", value: "KE", id: 32, group: "Africa", region: "002" },
  { label: "Latvia", value: "LV", id: 33, group: "Europe", region: "150" },
  { label: "Lebanon", value: "LB", id: 34, group: "Asia", region: "142" },
  {
    label: "Liechtenstein",
    value: "LI",
    id: 35,
    group: "Europe",
    region: "150",
  },
  { label: "Lithuania", value: "LT", id: 36, group: "Europe", region: "150" },
  {
    label: "Luxembourg",
    value: "LU",
    id: 37,
    group: "Europe",
    region: "150",
  },
  { label: "Macao", value: "MO", id: 38, group: "Asia", region: "142" },
  { label: "Malta", value: "MT", id: 39, group: "Europe", region: "150" },
  { label: "Malaysia", value: "MY", id: 40, group: "Asia", region: "142" },
  {
    label: "Mexico",
    value: "MX",
    id: 41,
    group: "South America",
    region: "419",
  },
  { label: "Moldova", value: "MD", id: 42, group: "Europe", region: "150" },
  { label: "Monaco", value: "MC", id: 43, group: "Europe", region: "150" },
  { label: "Morocco", value: "MA", id: 44, group: "Africa", region: "002" },
  {
    label: "Netherlands",
    value: "NL",
    id: 45,
    group: "Europe",
    region: "150",
  },
  {
    label: "New Zealand",
    value: "NZ",
    id: 46,
    group: "Oceania",
    region: "009",
  },
  { label: "Nigeria", value: "NG", id: 47, group: "Africa", region: "002" },
  { label: "Norway", value: "NO", id: 48, group: "Europe", region: "150" },
  { label: "Pakistan", value: "PK", id: 49, group: "Asia", region: "142" },
  {
    label: "Philippines",
    value: "PH",
    id: 50,
    group: "Asia",
    region: "142",
  },
  { label: "Poland", value: "PL", id: 51, group: "Europe", region: "150" },
  { label: "Portugal", value: "PT", id: 52, group: "Europe", region: "150" },
  { label: "Romania", value: "RO", id: 53, group: "Europe", region: "150" },
  { label: "Russia", value: "RU", id: 54, group: "Europe", region: "150" },
  { label: "Singapore", value: "SG", id: 55, group: "Asia", region: "142" },
  { label: "Slovakia", value: "SK", id: 56, group: "Europe", region: "150" },
  { label: "Slovenia", value: "SI", id: 57, group: "Europe", region: "150" },
  {
    label: "South Africa",
    value: "ZA",
    id: 58,
    group: "Africa",
    region: "002",
  },
  { label: "Spain", value: "ES", id: 59, group: "Europe", region: "150" },
  { label: "Sweden", value: "SE", id: 60, group: "Europe", region: "150" },
  {
    label: "Switzerland",
    value: "CH",
    id: 61,
    group: "Europe",
    region: "150",
  },
  {
    label: "South Korea",
    value: "KR",
    id: 62,
    group: "Asia",
    region: "142",
  },
  { label: "Taiwan", value: "TW", id: 63, group: "Asia", region: "142" },
  { label: "Thailand", value: "TH", id: 64, group: "Asia", region: "142" },
  { label: "Turkey", value: "TR", id: 65, group: "Asia", region: "142" },
  { label: "Ukraine", value: "UA", id: 66, group: "Europe", region: "150" },
  {
    label: "United Arab Emirates",
    value: "AE",
    id: 67,
    group: "Asia",
    region: "142",
  },
  {
    label: "United Kingdom",
    value: "GB",
    id: 68,
    group: "Europe",
    region: "150",
  },
  {
    label: "United States",
    value: "US",
    id: 69,
    group: "Northern America",
    region: "021",
  },
  { label: "Vietnam", value: "VN", id: 70, group: "Asia", region: "142" },
];

export const availableSelection: Filter[] = [
  { label: "Available", value: 1, id: 1 },
  { label: "Unavailable", value: 0, id: 2 },
];

export const currencySelection: Filter[] = [
  { label: "USD", value: "USD", id: 1 },
  { label: "EUR", value: "EUR", id: 2 },
  { label: "CAD", value: "CAD", id: 3 },
  { label: "GBP", value: "GBP", id: 4 },
  { label: "AUD", value: "AUD", id: 5 },
  { label: "NZD", value: "NZD", id: 6 },
  { label: "SEK", value: "SEK", id: 7 },
  { label: "DKK", value: "DKK", id: 8 },
  { label: "JPY", value: "JPY", id: 9 },
  { label: "SGD", value: "SGD", id: 10 },
  { label: "KRW", value: "KRW", id: 11 },
  { label: "HKD", value: "HKD", id: 12 },
];

export const sortSelecton: Filter[] = [
  { label: "Newest", value: "newest", id: 1 },
  { label: "Oldest", value: "oldest", id: 2 },
  { label: "Lowest $", value: "lowest", id: 3 },
  { label: "Highest $", value: "highest", id: 4 },
];

export const relevanceSortOption: Filter = {
  label: "Most Relevant",
  value: "relevance",
  id: 5,
};

export const imageSearchSortSelection: Filter[] = [
  { label: "Best Match", value: "best_match", id: 0 },
  { label: "Newest", value: "newest", id: 1 },
  { label: "Oldest", value: "oldest", id: 2 },
  { label: "Lowest $", value: "lowest", id: 3 },
  { label: "Highest $", value: "highest", id: 4 },
];

export const defaultFilters = {
  available: [{ id: 1, included: true, label: "Available", value: 1 }],
  type: [],
  brands: [],
  vendors: [],
  regions: [],
  continents: [],
  price: [],
  currency: [{ id: 0, included: true, label: "USD", value: "USD" }],
  sort: [{ id: 0, included: true, label: "Newest", value: "newest" }],
};

export const proxies = [
  {
    region: "Japan",
    proxies: [
      { title: "Buyee", link: "https://buyee.jp/?lang=en" },
      { title: "Fromjapan*", link: "https://www.fromjapan.co.jp/en/" },
      { title: "Zenmarket*", link: "https://zenmarket.jp/en/" },
      { title: "Japan Rabbit*", link: "https://www.whiterabbitexpress.com/" },
    ],
  },
  {
    region: "United Kingdom",
    proxies: [{ title: "Myus", link: "https://www.myus.com/" }],
  },
  {
    region: "South Korea",
    proxies: [
      { title: "Harum*", link: "https://www.harum.io/pages/buy-from-korea" },
      {
        title: "Expat Kid Korea",
        link: "https://www.expatkidskorea.com/listing/package-forwarding-services",
      },
    ],
  },
  {
    region: "United States",
    proxies: [{ title: "Myus", link: "https://www.myus.com/" }],
  },
];

export const stylesTypes = [
  { label: "Punk", value: "punk", image: "filters/punk.avif" },
  { label: "Eccentric", value: "eccentric", image: "filters/eccentric.avif" },
  { label: "Street", value: "street", image: "filters/street.avif" },
  { label: "Workwear", value: "workwear", image: "filters/workwear.avif" },
  { label: "Fancy", value: "fancy", image: "filters/fancy.avif" },
  { label: "Casual", value: "casual", image: "filters/casual.avif" },
  {
    label: "Avant Garde",
    value: "avant garde",
    image: "filters/avant-garde.avif",
  },
  { label: "Gothic", value: "gothic", image: "filters/gothic.avif" },
  { label: "Dandy", value: "dandy", image: "filters/dandy.avif" },
  { label: "Tech", value: "tech", image: "filters/tech.avif" },
];

export const englishRegions = [
  "United States",
  "United Kingdom",
  "Australia",
  "Canada",
  "New Zealand",
];

export const VENDOR_TYPES: Record<number, string> = {
  0: "Independent Seller",
  1: "Chains",
  2: "Marketplace",
  3: "Auction House",
};

export const getVendorType = (type: number | null | undefined): string => {
  if (type === null || type === undefined) return "";
  return VENDOR_TYPES[type] ?? "";
};
